/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ButtonBase,
  IconButton,
  ListItem,
  Menu,
  Typography
} from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import React, { useState } from 'react'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../helpers/date'
import { addCommaToPrice } from '../../helpers/numbers'
import { persianRegex } from '../../helpers/regex'
import { getTranslate, lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { TransactionStatus } from '../../types/walletEnums'
import { WalletTransaction } from '../../types/walletTransaction'
import FundingModeLabel from './FundingModeLabel'
import PaymentStatusBox from './PaymentStatusBox'
import ReferencesModal from './ReferencesModal'
import StatusBox from './StatusBox'
import TransactionHistoryModal from './TransactionHistoryModal'
import WalletTransactionSupportAction from './WalletTransactionSupportAction'
import useStyles from './styles/WalletListTableDesktop.styles'

interface WalletTransactionListTableRowDesktopProps {
  data: WalletTransaction
  /** Required: the stale-list guard has no safe default. */
  supportAvailable: boolean
}

export const WalletTransactionListTableRowDesktop: React.FC<
  WalletTransactionListTableRowDesktopProps
> = ({ data, supportAvailable }) => {
  const classes = useStyles()

  const isPersianSenderWallet =
    data.walletID && persianRegex.test(data.correlationID)
  const [referencesModalIsOpen, setreferencesModalIsOpen] =
    useState<boolean>(false)
  const [transactionHistoryModalIsOpen, settransactionHistoryModalIsOpen] =
    useState<boolean>(false)
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)
  const handleClickMoreOptions = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={[classes.tableRowRoot].join(' ')}>
      <div
        className={
          data?.creditorID ? classes.tableRow : classes.tableRowWithoutCreditor
        }>
        <div
          className={classes.nameCell}
          style={
            isPersianSenderWallet ? { fontFamily: 'IranSans' } : undefined
          }>
          <Typography variant="h4">
            {lang === 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(data.time)
              : data.time}
          </Typography>
        </div>
        {data.creditorID && data.creditorEntity && (
          <div>
            <Typography variant="body1">
              {data.creditorEntity.entityType +
                '-' +
                data.creditorEntity.entityName +
                '-' +
                data.currency}
            </Typography>
          </div>
        )}

        <div>
          <Typography variant="body1">{getTranslate(data.type)}</Typography>
        </div>
        <div className={classes.flex}>
          <Typography variant="body1">
            {addCommaToPrice(data.amount) +
              ` ${getTranslate(data.currency || '')}`}
          </Typography>
        </div>
        <div>
          <FundingModeLabel transaction={data} />
        </div>
        <div>
          <Typography
            variant="body1"
            className={
              data.sumOfPenalty > 0
                ? classes.penaltyText
                : data.rewardOfEarlyPayment > 0
                ? classes.rewardText
                : undefined
            }>
            {data.sumOfPenalty > 0
              ? '-' +
                addCommaToPrice(data.sumOfPenalty) +
                ` ${getTranslate(data.currency || '')}`
              : data.rewardOfEarlyPayment > 0
              ? '+' +
                addCommaToPrice(data.rewardOfEarlyPayment) +
                ` ${getTranslate(data.currency || '')}`
              : '0'}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{data.description}</Typography>
        </div>
        <div>
          <Typography>
            <PaymentStatusBox status={data.paymentStatus} />
          </Typography>
        </div>
        <div>
          <Typography>
            <StatusBox status={data.status as TransactionStatus} />
          </Typography>
        </div>
        <div>
          <IconButton
            aria-label={getTranslate('Transaction actions')}
            aria-haspopup="menu"
            aria-expanded={Boolean(anchorEl)}
            aria-controls={
              anchorEl ? `transaction-actions-${data.transactionID}` : undefined
            }
            onClick={handleClickMoreOptions}>
            <MoreIcon />
          </IconButton>
          <Menu
            id={`transaction-actions-${data.transactionID}`}
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}>
            <WalletTransactionSupportAction
              transactionID={data.transactionID}
              available={supportAvailable}
            />
            <ListItem
              // disabled={data.references.length === 0}
              button
              onClick={() => setreferencesModalIsOpen(true)}>
              {getTranslate('References')}
            </ListItem>
            <ListItem
              // disabled={data.references.length === 0}
              button
              onClick={() => settransactionHistoryModalIsOpen(true)}>
              {getTranslate('Transaction History')}
            </ListItem>
          </Menu>
        </div>
        <TransactionHistoryModal
          isOpen={transactionHistoryModalIsOpen}
          onClose={() => settransactionHistoryModalIsOpen(false)}
          transactionID={data.transactionID}
        />
        <ReferencesModal
          isOpen={referencesModalIsOpen}
          onClose={() => setreferencesModalIsOpen(false)}
          transactionID={data.transactionID}
        />
      </div>
    </div>
  )
}
